import { cloneDeep, set } from "lodash";

export const toUppercase = (state, action) => {
  switch (action.type) {
    case "@@redux-form/BLUR":
    case "@@redux-form/AUTOFILL":
      if (typeof action.payload === "string") {
        const values = cloneDeep(state.values);

        set(values, action.meta.field, action.payload.toUpperCase());
        return {
          ...state,
          values,
        };
      }
      return state;
    default:
      return state;
  }
};
